var _rect, _g, _g2, _g3, _path, _g4, _circle, _g5, _circle2, _g6, _text, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#2BB4A0",
    width: 178.6,
    height: 260.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A8894E",
    d: "M88.4,134.5l-33.2-19.4c-12.5-4.1-26,2.7-30.2,15.1c-4.1,12.5,2.7,26,15.1,30.2l38.2,4.3 C90.9,168.9,100.9,138.7,88.4,134.5z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    opacity: 0.4,
    d: "M88.4,134.5l-33.2-19.4c-12.5-4.1-26,2.7-30.2,15.1c-4.1,12.5,2.7,26,15.1,30.2l38.2,4.3 C90.9,168.9,100.9,138.7,88.4,134.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#9A7143",
    d: "M45.7,197.1l71.2-35.7l-0.3-0.5l0.5-0.3L81.4,89.4l-0.5,0.3l-0.3-0.5 L9.5,124.8l0.3,0.5l-0.5,0.3l35.7,71.2l0.5-0.3L45.7,197.1z M66.5,151l3,6l-6,3l-3-6L66.5,151z M59.9,153l-3-6l6-3l3,6L59.9,153z  M67.5,150.5l6-3l3,6l-6,3L67.5,150.5z M67,149.4l-3-6l6-3l3,6L67,149.4z M63.4,142.3l-3-6l6-3l3,6L63.4,142.3z M71.1,139.8l6-3 l3,6l-6,3L71.1,139.8z M70.5,138.7l-3-6l6-3l3,6L70.5,138.7z M67,131.6l-3-6l6-3l3,6L67,131.6z M65.9,132.2l-6,3l-3-6l6-3 L65.9,132.2z M58.8,135.7l-6,3l-3-6l6-3L58.8,135.7z M59.3,136.8l3,6l-6,3l-3-6L59.3,136.8z M55.2,146.4l-6,3l-3-6l6-3L55.2,146.4 z M55.8,147.5l3,6l-6,3l-3-6L55.8,147.5z M59.3,154.6l3,6l-6,3l-3-6L59.3,154.6z M62.9,161.7l3,6l-6,3l-3-6L62.9,161.7z M64,161.2 l6-3l3,6l-6,3L64,161.2z M71.1,157.6l6-3l3,6l-6,3L71.1,157.6z M78.2,154l6-3l3,6l-6,3L78.2,154z M77.7,153l-3-6l6-3l3,6L77.7,153 z M81.7,143.4l6-3l3,6l-6,3L81.7,143.4z M81.2,142.3l-3-6l6-3l3,6L81.2,142.3z M77.6,135.2l-3-6l6-3l3,6L77.6,135.2z M74.1,128.1 l-3-6l6-3l3,6L74.1,128.1z M70.5,121l-3-6l6-3l3,6L70.5,121z M69.4,121.5l-6,3l-3-6l6-3L69.4,121.5z M62.3,125.1l-6,3l-3-6l6-3 L62.3,125.1z M55.2,128.6l-6,3l-3-6l6-3L55.2,128.6z M48.1,132.2l-6,3l-3-6l6-3L48.1,132.2z M48.6,133.2l3,6l-6,3l-3-6L48.6,133.2 z M44.6,142.9l-6,3l-3-6l6-3L44.6,142.9z M45.1,143.9l3,6l-6,3l-3-6L45.1,143.9z M48.7,151l3,6l-6,3l-3-6L48.7,151z M52.2,158.2 l3,6l-6,3l-3-6L52.2,158.2z M55.8,165.3l3,6l-6,3l-3-6L55.8,165.3z M59.4,172.4l3,6l-6,3l-3-6L59.4,172.4z M60.4,171.9l6-3l3,6 l-6,3L60.4,171.9z M67.5,168.3l6-3l3,6l-6,3L67.5,168.3z M74.6,164.7l6-3l3,6l-6,3L74.6,164.7z M81.8,161.2l6-3l3,6l-6,3 L81.8,161.2z M88.9,157.6l6-3l3,6l-6,3L88.9,157.6z M88.3,156.5l-3-6l6-3l3,6L88.3,156.5z M92.4,146.9l6-3l3,6l-6,3L92.4,146.9z  M91.9,145.8l-3-6l6-3l3,6L91.9,145.8z M88.3,138.7l-3-6l6-3l3,6L88.3,138.7z M84.8,131.6l-3-6l6-3l3,6L84.8,131.6z M81.2,124.5 l-3-6l6-3l3,6L81.2,124.5z M77.6,117.4l-3-6l6-3l3,6L77.6,117.4z M74.1,110.3l-3-6l6-3l3,6L74.1,110.3z M73,110.8l-6,3l-3-6l6-3 L73,110.8z M65.9,114.4l-6,3l-3-6l6-3L65.9,114.4z M58.8,117.9l-6,3l-3-6l6-3L58.8,117.9z M51.7,121.5l-6,3l-3-6l6-3L51.7,121.5z  M44.5,125.1l-6,3l-3-6l6-3L44.5,125.1z M37.4,128.6l-6,3l-3-6l6-3L37.4,128.6z M38,129.7l3,6l-6,3l-3-6L38,129.7z M33.9,139.3 l-6,3l-3-6l6-3L33.9,139.3z M34.4,140.4l3,6l-6,3l-3-6L34.4,140.4z M38,147.5l3,6l-6,3l-3-6L38,147.5z M41.5,154.6l3,6l-6,3l-3-6 L41.5,154.6z M45.1,161.7l3,6l-6,3l-3-6L45.1,161.7z M48.7,168.8l3,6l-6,3l-3-6L48.7,168.8z M52.2,176l3,6l-6,3l-3-6L52.2,176z  M55.8,183.1l3,6l-6,3l-3-6L55.8,183.1z M56.9,182.5l6-3l3,6l-6,3L56.9,182.5z M64,179l6-3l3,6l-6,3L64,179z M71.1,175.4l6-3l3,6 l-6,3L71.1,175.4z M78.2,171.8l6-3l3,6l-6,3L78.2,171.8z M85.3,168.3l6-3l3,6l-6,3L85.3,168.3z M92.4,164.7l6-3l3,6l-6,3 L92.4,164.7z M99.6,161.1l6-3l3,6l-6,3L99.6,161.1z M99,160.1l-3-6l6-3l3,6L99,160.1z M103.1,150.5l6-3l3,6l-6,3L103.1,150.5z  M102.6,149.4l-3-6l6-3l3,6L102.6,149.4z M99,142.3l-3-6l6-3l3,6L99,142.3z M95.4,135.2l-3-6l6-3l3,6L95.4,135.2z M91.9,128l-3-6 l6-3l3,6L91.9,128z M88.3,120.9l-3-6l6-3l3,6L88.3,120.9z M84.7,113.8l-3-6l6-3l3,6L84.7,113.8z M81.2,106.7l-3-6l6-3l3,6 L81.2,106.7z M77.6,99.6l-3-6l6-3l3,6L77.6,99.6z M76.5,100.1l-6,3l-3-6l6-3L76.5,100.1z M69.4,103.7l-6,3l-3-6l6-3L69.4,103.7z  M62.3,107.3l-6,3l-3-6l6-3L62.3,107.3z M55.2,110.8l-6,3l-3-6l6-3L55.2,110.8z M48.1,114.4l-6,3l-3-6l6-3L48.1,114.4z M41,118 l-6,3l-3-6l6-3L41,118z M33.9,121.5l-6,3l-3-6l6-3L33.9,121.5z M26.7,125.1l-6,3l-3-6l6-3L26.7,125.1z M27.3,126.2l3,6l-6,3l-3-6 L27.3,126.2z M23.2,135.8l-6,3l-3-6l6-3L23.2,135.8z M23.7,136.8l3,6l-6,3l-3-6L23.7,136.8z M27.3,143.9l3,6l-6,3l-3-6L27.3,143.9 z M30.9,151.1l3,6l-6,3l-3-6L30.9,151.1z M34.4,158.2l3,6l-6,3l-3-6L34.4,158.2z M38,165.3l3,6l-6,3l-3-6L38,165.3z M41.6,172.4 l3,6l-6,3l-3-6L41.6,172.4z M45.1,179.5l3,6l-6,3l-3-6L45.1,179.5z M48.7,186.6l3,6l-6,3l-3-6L48.7,186.6z M109.7,163.6l-3-6l6-3 l3,6L109.7,163.6z M16.6,122.6l3,6l-6,3l-3-6L16.6,122.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#45404B",
    d: "M134.5,144.4c0,0-4.2-0.8-4.7,0.3c-0.5,1.1,0.5,2,2.3,3.8l-0.9,1.4c0,0-3.1-1.3-3.9-0.2 c-0.6,0.8,0.1,1.8,1.3,3.5l-1.2,1.4c0,0-2.5-1.3-3.1-0.5c-0.4,0.5-0.3,1.2,0.8,2.9l-1.6,1.4c0,0-2.2-1.2-2.9-0.7 c-0.7,0.5-0.8,1.2-0.5,2.6l-0.3,0.1l-3.5-6.7l4.7-5.7l4.2-5.1l1.6-1.2L134.5,144.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "117.6,144.8 112.6,150.9 127.9,161.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "120.1,141.6 115.5,147.3 131.5,156.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "115.5,147.2 112.3,151.2 121,161.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "122.2,139.1 117.9,144.3 135.7,151.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "123.4,137.6 119.8,142 137.6,145  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#45404B",
    d: "M95.1,177.7c0,0-1-4.2,0.1-4.7c1.1-0.6,2,0.4,3.9,2.1l1.4-0.9c0,0-1.4-3.1-0.4-3.9c0.8-0.7,1.8,0,3.5,1.2 l1.3-1.2c0,0-1.5-2.5-0.6-3.1c0.5-0.4,1.2-0.4,3,0.7l1.3-1.6c0,0-1.3-2.1-0.8-2.8c0.5-0.7,1.2-0.9,2.6-0.6l0-0.3l-6.8-3.2l-5.4,5 l-4.9,4.4l-1.1,1.7L95.1,177.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "94.8,160.7 100.7,155.5 111.7,170.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "91.8,163.4 97.3,158.5 107.4,174.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "97.1,158.6 101,155.2 112,163.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "89.3,165.6 94.4,161.1 102.5,178.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "86.5,165 92.1,163.1 95.8,180.7  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9A7143",
    d: "M43.2,49.9c-18.6,10.2-11.5,28.4-0.6,52.4c6.5,14.3-7.6,21.6,2,39c12.1,22.1,38.4,30.5,60.4,18.4 c24-13.1,29.7-40.1,17.4-62.1C114.5,83.8,73.6,33.2,43.2,49.9z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 49.3,
    cy: 76.8,
    r: 4.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M48.9,75.3c0.2,0.7-0.2,1.5-1,1.7c-0.5,0.1-1.1,0-1.4-0.4c0,0.3,0,0.6,0.1,0.9c0.4,1.5,1.9,2.4,3.4,2 c1.5-0.4,2.4-1.9,2-3.4s-1.9-2.4-3.4-2c-0.2,0.1-0.4,0.1-0.6,0.3C48.4,74.5,48.8,74.9,48.9,75.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 68.2,
    cy: 60.5,
    r: 4.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M67.8,59.1c0.2,0.7-0.2,1.5-1,1.7c-0.5,0.1-1.1,0-1.4-0.4c0,0.3,0,0.6,0.1,0.9c0.4,1.5,1.9,2.4,3.4,2 c1.5-0.4,2.4-1.9,2-3.4c-0.4-1.5-1.9-2.4-3.4-2c-0.2,0.1-0.4,0.1-0.6,0.3C67.3,58.2,67.7,58.6,67.8,59.1z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 20.8,
    cy: 39.2,
    r: 2.6
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 15.5643 29.7173)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "5"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 146.4,
    cy: 210.3,
    r: 2.6
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-1 0 0 -1 151.6725 219.7435)",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "5"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 48.3574 196.6374)",
    fontFamily: "'RobotoSlab-Thin'",
    fontSize: 140
  }, "5")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#1A4E47",
    cx: 32.9,
    cy: 193.2,
    r: 6.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#1A4E47",
    cx: 136.9,
    cy: 24.2,
    r: 4.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#1A4E47",
    cx: 139.4,
    cy: 51.7,
    r: 5.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#1A4E47",
    cx: 44.7,
    cy: 211.4,
    r: 8.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#1A4E47",
    cx: 23.7,
    cy: 221.4,
    r: 3.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#1A4E47",
    cx: 126.4,
    cy: 37.2,
    r: 4.6
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#45404B",
    d: "M62.7,143.7c0,0-3-3-2.4-4c0.6-1.1,1.9-0.8,4.4-0.2l0.7-1.5c0,0-2.8-1.9-2.4-3.1c0.3-1,1.5-0.9,3.6-0.8 l0.5-1.8c0,0-2.5-1.3-2.2-2.3c0.2-0.6,0.8-0.9,2.9-1l0.3-2.1c0,0-2.2-1.1-2.2-2c0-0.9,0.6-1.4,1.9-1.9l-0.1-0.3l-7.5,0.9l-2,7.1 l-1.9,6.3l-0.1,2L62.7,143.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "53.5,129.5 55.8,121.9 73,128.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "52.4,133.3 54.5,126.3 71.3,134.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "54.4,126.4 55.9,121.5 69.6,122.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "51.4,136.5 53.4,130 69.4,140.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "50.9,138.3 52.5,132.9 65,145.9  "
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3352 0.9422 -0.9422 -0.3352 188.7524 124.1378)",
    fill: "#9A7143",
    cx: 50.6,
    cy: 128.7,
    rx: 13.4,
    ry: 5.9
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#45404B",
    d: "M109.1,126.5c0,0,1.4-4,0.5-4.7c-1-0.7-2.1,0.1-4.1,1.7l-1.2-1.1c0,0,1.7-2.9,0.8-3.9 c-0.7-0.8-1.8-0.2-3.6,0.8l-1.2-1.4c0,0,1.7-2.3,1-3c-0.5-0.5-1.2-0.5-3,0.4l-1.1-1.8c0,0,1.5-2,1.1-2.7c-0.4-0.8-1.1-1-2.5-0.9 l0-0.3l7.1-2.4l4.9,5.5l4.4,4.9l0.9,1.8L109.1,126.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "111.3,109.7 106,103.9 93.4,117.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "114,112.7 109.1,107.3 97.3,121.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "109.2,107.4 105.7,103.6 93.9,110.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "116.2,115.2 111.7,110.2 101.7,126.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545A63",
    points: "117.5,116.6 113.7,112.4 108.1,129.5  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A7143",
    d: "M124.7,115.6c-3.2,3.2-10,1.5-15.2-3.7c-5.2-5.2-6.9-12-3.7-15.2c3.2-3.2,4.4,0.7,9.6,5.9 C120.6,107.9,127.8,112.5,124.7,115.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5B5557",
    d: "M83.1,76.9c1.6-1.8,0.9-3.5-0.6-5.5c-1.9-2.3-5-1.8-7.9-1.2c-1.2,0.2-8.5-0.1-11.9,2.5 c-3.2,2.7-4.4,9.9-4.9,11.1c-1.1,2.7-2.3,5.7-0.4,8c1.6,2,3.1,2.9,5.2,1.8c1.3-0.6,1.7,0,2.2,0.7c0.5,0.6,7.8,7,8.7,8.8 c0.3,1.3,0.2,3.4,1.2,4.6c1.5,1.8,3.6,1.7,5.4,0.2c0.8-0.6,3.3-3.4,6.2-5.7s6.1-4.2,6.9-4.9c1.8-1.5,2.4-3.5,0.9-5.3 c-1-1.2-3.1-1.6-4.3-2.2c-1.6-1.2-6.2-9.7-6.8-10.3S82.3,78,83.1,76.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2D3130",
    cx: 80.6,
    cy: 101.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D3130",
    cx: 87.1,
    cy: 96.1,
    r: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.e71a4fae45c2db633ed742c4a684fb55.svg";
export { ForwardRef as ReactComponent };